import * as React from "react";
import { useState, useEffect, useContext, useRef } from "react";
import { DataGrid, GridColumns, GridRowsProp } from "@mui/x-data-grid";

import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import TextField from "@mui/material/TextField";

/*  T O O L B A R  */
import NewIcon from "@mui/icons-material/InsertDriveFile";
import SaveIcon from "@mui/icons-material/Save";
import IconButton from "@mui/material/IconButton";
import EraseIcon from "@mui/icons-material/Delete";
import { confirmAlert } from "react-confirm-alert";

/*  T O O L T I P  */
import Tooltip from "@mui/material/Tooltip";

/* G R I D  */
import Grid from "@mui/material/Grid";

/* C U S T O M I Z A D O  S */
import JustificativasTopo from "./topo";
import Justificativa from "../../components/classes/JustificativaDomain";
import JustificativaDataset from "../../components/data/JustificativaDataSet";
import { hasInCache } from "../../helper/cacheHelper";
import PageHelper from "../../helper/pageHelper";
import Button from "@mui/material/Button";

/* Alert */
import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
import CloseIcon from "@mui/icons-material/Close";

/* Dialog */
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

/* LOCALIZAÇÃO */
import { format } from "date-fns";
import { pt } from "date-fns/locale";
import { UserContext } from "../../App";
// import style from './detalhe.module.css'

import { useTranslation } from "react-i18next";

interface Data {
  id: number;
  descricao: string;
}

export const JustificativasDetalhe = () => {
  const { t } = useTranslation();
  const user: any = useContext(UserContext);
  const [nada, SetNada] = useState<Justificativa[]>([]);

  const [justificativas, SetJustificativas] = useState<Justificativa[]>([]);
  const [registro, SetRegistro] = useState<Justificativa>(
    () => new Justificativa()
  );
  const [excluiItem, setExcluiItem] = useState(false);
  const [itemToExcluir, setItemExcluir] = useState<Justificativa>(
    () => new Justificativa()
  );
  const data: JustificativaDataset = new JustificativaDataset();

  const [codigoFornecedorSap, setCodigoFornecedorSap] = useState(0);

  const [habilita, setHabilita] = useState(false);
  const [open, setOpen] = useState(false);
  const [openMsg, setOpenMsg] = useState(true);

  const [loading, setloading] = useState(false);
  const [refresh, setRefresh] = useState(false);

  const [columns, setColumns] = useState<GridColumns>([]);
  const [rows, setRows] = useState<Data[]>([]);

  const [mensagem, setMensagem] = useState("");
  const [severity, setSeverity] = useState(0);
  const [rowsLancamento, setRowsLancamento] = useState<Justificativa[]>([]);
  const [rowsPedido, setRowsPedido] = useState<Justificativa[]>([]);
  const [rowsCausador, setRowsCausador] = useState<Justificativa[]>([]);
  const [tab, setTab] = React.useState("Lancamento");

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setTab(newValue);
  };

  function createData(id: number, descricao: string): Data {
    return {
      id,
      descricao,
    };
  }

  useEffect(() => {
    setloading(true);
    data.ListarAtivos().then((result) => {
      // console.log(JSON.stringify(result));
      setRowsLancamento(result.filter((j) => j.categoria == "Lancamento"));
      setRowsPedido(result.filter((j) => j.categoria == "Pedido"));
      setRowsCausador(result.filter((j) => j.categoria == "Causador"));
      setloading(false);
      if (result.length > 0) {
        MontaColunas();
        preencherGrid(result);
      }
    });
  }, []);

  const textInput = useRef<any>("");

  const handleClickNew = () => {
    setHabilita(true);
    SetRegistro(new Justificativa());
    textInput.current.focus();
  };

  const handlerDescricaoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    SetRegistro((previousState) => {
      return { ...previousState, descricao: e.target.value };
    });
  };

  const handleIncluirClick = () => {
    var justificativaToAdd = new Justificativa();
    justificativaToAdd.descricao = registro.descricao;
    justificativaToAdd.categoria =
      tab === "Lancamento"
        ? "Lancamento"
        : tab === "Pedido"
        ? "Pedido"
        : "Causador";
    data.Adicionar(justificativaToAdd);

    Mensagem(
      t("common.warning"),
      t("pages.justifications.text.successNewProperty")
    );
    handleClickNew();
    setHabilita(false);
  };

  const handleAtualizaClick = () => {
    var justificativaToUpd = new Justificativa();
    justificativaToUpd.descricao = registro.descricao;
    justificativaToUpd.categoria =
      tab === "Lancamento"
        ? "Lancamento"
        : tab === "Pedido"
        ? "Pedido"
        : "Causador";
    justificativaToUpd.id = registro.id;
    data.Atualizar(justificativaToUpd);
    Mensagem(
      t("common.warning"),
      t("pages.justifications.text.successUpdateProperty")
    );
    handleClickNew();
    setHabilita(false);
  };

  const Mensagem = (titulo: string, mensagem: string) => {
    return confirmAlert({
      title: titulo,
      message: mensagem,
      buttons: [
        {
          label: "Ok",
          onClick: () => {
            setOpen(false);
            PageHelper.refreshPage();
          },
        },
      ],
    });
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  //delete / seleciona
  const handleClick = (cellValues: any) => {
    if (cellValues.field === "deleteico" && !user.isSuporte) {
      setItemExcluir(
        (tab === "Lancamento"
          ? rowsLancamento
          : tab === "Pedido"
          ? rowsPedido
          : rowsCausador
        ).filter((f) => f.id === cellValues.row.id)[0]
      );
      handleClickOpen();
    }
  };

  useEffect(() => {
    if (excluiItem === true) {
      data.Apagar(itemToExcluir);
      localStorage.removeItem("justificativaIdSel");
      setMensagem(
        t("pages.justifications.text.justificationExclusionWithSuccess")
      );
      setSeverity(0);
      PageHelper.refreshPage();
    }
    setExcluiItem(false);
    setItemExcluir(new Justificativa());
    setRefresh(!refresh);
  }, [excluiItem]);

  const handleSelectionChange = (id: any) => {
    if (id !== null && id !== undefined && id > 0) {
      localStorage.setItem("justificativaIdSel", id);
      // eslint-disable-next-line array-callback-return
      justificativas.map(function (item: Justificativa) {
        if (item.id === Number(id)) {
          SetRegistro(item);
          setHabilita(true);
        }
      });
    } else {
      localStorage.removeItem("justificativaIdSel");
      setHabilita(false);
    }
  };

  function preencherGrid(_itens: Justificativa[]) {
    setRows(
      _itens.map((_Item: Justificativa) => {
        return createData(Number(_Item.id), String(_Item.descricao));
      })
    );
    setloading(false);
  }

  function TransitionAlerts(_severity: number, _mensagem: string) {
    return (
      <Box
        className="divAlert"
        sx={{
          width: "50%",
          position: "absolute",
          zIndex: "1000",
          left: "25%",
          top: "30%",
        }}
      >
        <Collapse in={openMsg}>
          <Alert
            severity={
              _severity === 0
                ? "success"
                : _severity === 1
                ? "info"
                : _severity === 2
                ? "warning"
                : "error"
            }
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={() => {
                  setOpenMsg(false);
                }}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            }
            sx={{ mb: 2 }}
          >
            {_mensagem}
          </Alert>
        </Collapse>
      </Box>
    );
  }

  function MontaColunas() {
    let columns1: GridColumns = [
      {
        field: "id",
        headerName: "#",
        type: "string",
        width: 100,
        headerAlign: "center",
        align: "center",
      },
      {
        field: "descricao",
        headerName: t("common.description"),
        type: "string",
        width: 520,
        headerAlign: "center",
        align: "left",
      },
      {
        field: "categoria",
        headerName: t("common.category"),
        type: "string",
        width: 520,
        headerAlign: "center",
        align: "left",
      },
      {
        field: "deleteico",
        headerName: "",
        sortable: false,
        filterable: false,
        hideable: false,
        disableColumnMenu: true,
        align: "center",
        renderCell: () => {
          return (
            <IconButton disabled={user.isSuporte}>
              {" "}
              <EraseIcon />
            </IconButton>
          );
        },
      },
    ];
    setColumns(columns1);
  }

  return (
    <div className="container">
      <JustificativasTopo />
      <div className="containerToolbar">
        <Tooltip title={t("pages.justifications.text.newJustification")}>
          <span>
            <IconButton onClick={handleClickNew} disabled={user.isSuporte}>
              <NewIcon />
            </IconButton>
          </span>
        </Tooltip>
        {registro.descricao.length > 0 ? (
          <Tooltip title={t("pages.justifications.text.updateParametersData")}>
            <span>
              <IconButton
                onClick={
                  registro.id === 0 ? handleIncluirClick : handleAtualizaClick
                }
                disabled={user.isSuporte}
              >
                <SaveIcon />
              </IconButton>
            </span>
          </Tooltip>
        ) : null}
      </div>
      <div className="insiderContainer">
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              inputRef={(textInput) => textInput && textInput.focus()}
              required
              id={"descricao"}
              name={"Descrição"}
              label={t("common.description")}
              fullWidth
              variant="outlined"
              value={registro.descricao}
              onChange={handlerDescricaoChange}
              disabled={!habilita}
            />
          </Grid>
        </Grid>
        <br />
      </div>
      <div className="insiderContainer">
        <>
          <div>
            <Dialog
              open={open}
              onClose={handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                {t("pages.justifications.text.excludeItemQuestionTitle")}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  {t("pages.justifications.text.excludeItemQuestionSubTitle")}
                  <br />
                  <br />
                  {t("pages.justifications.text.justification")} :{" "}
                  <strong>
                    {itemToExcluir.descricao}
                    <strong />
                  </strong>
                  <br />
                  {t(
                    "pages.justifications.text.excludeItemQuestionConfirmation"
                  )}
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  color="error"
                  onClick={() => {
                    setExcluiItem(true);
                    handleClose();
                  }}
                >
                  {t("common.yes")}
                </Button>
                <Button
                  variant="outlined"
                  color="success"
                  onClick={handleClose}
                  autoFocus
                >
                  {t("common.no")}
                </Button>
              </DialogActions>
            </Dialog>
          </div>
          {
            <div className="insiderContainer">
              <Box sx={{ width: "100%" }}>
                <Tabs
                  value={tab}
                  onChange={handleChange}
                  textColor="secondary"
                  indicatorColor="secondary"
                  aria-label="secondary tabs example"
                >
                  <Tab value="Lancamento" label={t("common.release")} />
                  <Tab value="Pedido" label={t("common.order")} />
                  <Tab value="Causador" label={t("common.causer")} />
                </Tabs>
              </Box>
              <div
                style={{
                  width: "100%",
                  height: "50vh",
                  backgroundColor: "#FFFAFA",
                  scrollBehavior: "auto",
                }}
              >
                <DataGrid
                  rows={
                    tab === "Lancamento"
                      ? rowsLancamento
                      : tab === "Pedido"
                      ? rowsPedido
                      : rowsCausador
                  }
                  columns={columns}
                  rowsPerPageOptions={[50, 100, 250, 500]}
                  disableSelectionOnClick
                  onCellClick={(cellValues) => {
                    handleClick(cellValues);
                  }}
                />
              </div>
              {mensagem.length > 0
                ? TransitionAlerts(severity, mensagem)
                : null}
            </div>
          }
        </>
      </div>
    </div>
  );
};
